import { ISiteV2 } from "../../../interfaces/Site";
import styles from "./SiteModuleImageGalleryItem.module.scss";
import { ISiteModuleImageGalleryItem } from "../../../interfaces/ISiteModule";
import { ContentTypeImage } from "../../../contentTypes/ContentTypeImage/ContentTypeImage";
import { useState } from "react";
import { GallerySlideshow } from "../components/GallerySlideshow/GallerySlideshow";

interface IProps {
    site: ISiteV2;
    listItem: ISiteModuleImageGalleryItem;
    gallery: ISiteModuleImageGalleryItem[];
}

export function SiteModuleImageGalleryItem(props: IProps) {
    const [showSlideshow, setShowSlideshow] = useState(false);
    return (
        <div className={`${styles[props.site.theme]}`}>
            {showSlideshow ? (
                <GallerySlideshow
                    startItem={props.listItem}
                    gallery={props.gallery}
                    handleClose={() => setShowSlideshow(false)}
                />
            ) : null}
            <div className={styles.imageWrapper}>
                <ContentTypeImage
                    sizes="(min-width: 750px) 600px, 100vw"
                    contentData={props.listItem.image}
                    site={props.site}
                    onClick={() => setShowSlideshow(true)}
                />
            </div>
        </div>
    );
}
